// The dead-air speculative assist path (apps/expert-ui/src/dead-air) tags its message with this
// exact string when it surfaces a suggestion; see useDeadAirAssist.ts. Exported from this package
// so the producer and every consumer here share one definition.
export const DEAD_AIR_TAG = "Dead air";
